import { useState } from "react";

import { useFetchSimulation, useSimulations } from "hooks/api/use-simulations";

import { useSmsSimulatorContext } from "containers/sms-simulator/sms-simulator.context";

import { SmsSimulatorSimulationSummaryAttributes } from "containers/sms-simulator/sms-simulator.types";

import { formatDateTime } from "utilities/date";

export const useSmsSimulatorSimulation = () => {
  const { currentSimulation, setCurrentSimulation } = useSmsSimulatorContext();

  const [isAllSimulationsCardOpen, setIsAllSimulationsCardOpen] = useState(false);
  const [isSimulatorMinimized, setIsSimulatorMinimized] = useState(false);

  const { data: simulations = [], isFetching: isLoadingAllSimulations } = useSimulations(undefined, {
    enabled: isAllSimulationsCardOpen,
  });
  const fetchSimulation = useFetchSimulation();

  const formatDate = (dateString: string) => formatDateTime(dateString);

  const handleAllSimulationsClick = () => {
    setIsAllSimulationsCardOpen((isOpen) => !isOpen);
  };

  const handleCloseAllSimulationsCard = () => {
    setIsAllSimulationsCardOpen(false);
  };

  const handleMinimizeClick = () => {
    setIsSimulatorMinimized(!isSimulatorMinimized);
  };

  const handleSelectSimulation = async (simulation: SmsSimulatorSimulationSummaryAttributes) => {
    try {
      const fullSimulation = await fetchSimulation(simulation.id);
      setCurrentSimulation(fullSimulation);
      setIsAllSimulationsCardOpen(false);
    } catch (error) {
      console.error("Failed to load simulation details:", error);
      setCurrentSimulation({
        ...simulation,
        simulationData: [],
      });
      setIsAllSimulationsCardOpen(false);
    }
  };

  return {
    simulations,
    currentSimulation,
    isAllSimulationsCardOpen,
    isLoadingAllSimulations,
    isSimulatorMinimized,
    formatDate,
    handleAllSimulationsClick,
    handleCloseAllSimulationsCard,
    handleMinimizeClick,
    handleSelectSimulation,
    setCurrentSimulation,
  };
};
